import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

export interface ErrorStateProps {
  title: string
  message?: string
  onRetry?: () => void
  className?: string
}

export function ErrorState({ title, message, onRetry, className }: ErrorStateProps) {
  return (
    <div role="alert" className={cn('flex flex-col items-center justify-center p-8 text-center', className)}>
      <AlertTriangle className="h-10 w-10 text-destructive mb-3" aria-hidden />
      <h3 className="text-base font-semibold text-foreground">{title}</h3>
      {message && <p className="mt-1 text-sm text-muted-foreground max-w-md">{message}</p>}
      {onRetry && (
        <Button variant="outline" size="sm" className="mt-4" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  )
}
